import axios from 'axios';

/**
 * 写真フォルダ取得
 */
export const getPictureFolders = (construct_id: number) => {
  return axios
    .get(`/api/v1/picture-folders?construct_id=${construct_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 写真詳細取得
export const getPictureDetailsById = (id: number) => {
  return axios
    .get(`/api/v1/picture/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * サムネイル取得（単一）
 */
export const getPictureThumbnailById = (id: number) => {
  return axios
    .get(`/api/v1/get/picture/thumbnail/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真ダウンロード（単一）
 */
export const downloadPictureById = (id: number) => {
  return axios
    .get(`/api/v1/get/picture/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getDownQualityPicture = async (id: number) => {
  return await axios
    .get(`/api/v1/get/down_quality/picture/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真更新
 */
export const editPictureDetailById = (
  id: number,
  shooting_date: string,
  description: string,
  file_name: string
) => {
  return axios
    .put(
      `api/v1/update/picture/${id}`,
      {
        shooting_date,
        description,
        file_name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真フォルダ名更新
 */
export const editPictureFolderById = (folder_id: any, name: string) => {
  return axios
    .post(
      `api/v1/update-folder/pictures/${folder_id}`,
      {
        folder_id,
        name
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真フォルダ閲覧権限変更
 */
export const updatePictureFolderAuthority = (
  folderId: number,
  outsidePartnerId: number[]
) => {
  return axios
    .post(
      `/api/v1/update-folder/pictures/authorities/${folderId}`,
      {
        outside_partner_ids: outsidePartnerId
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(res => {
      return res.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 写真フォルダの閲覧権限がある社外パートナーのIDを取得
 */
export const getAuthorizedOutsidePartner = (folderId: number) => {
  return axios
    .get(
      `/api/v1/get-folder/pictures/authorized_outside_partner_ids/${folderId}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(res => {
      return res.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
